











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Product } from "@/data/productCategory/product/product";
import { Paper } from "@/data/productCategory/product/paper/paper";

import PaperPreview from "./paperPreview/paperPreview.vue";

import * as def from "@/definitions";
@Component({
  components: {
    PaperPreview
  }
})
export default class RightController extends Vue {
    @Prop()
    private paperList!: Paper[];
    @Prop()
    private selectedPaper!: Paper;
    @Prop()
    private selectedProduct!: Product;
    selectPaper(paperId : number){
        this.$emit("selectPaper" , paperId)
    }

    @Prop() private paperRotation! : number;

    private onClickGoNext()
    {
        this.$emit("doCommand", "goNext", null);
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
